export const restoreState = () => {
    try {
        const serializedState = localStorage.getItem('redux-state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch (e) {
        console.warn(`Failed to load state from local storage`);
        return undefined;
    }
}

export const persistState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('redux-state', serializedState);
    }
    catch (e) {
        console.warn(`Failed to save state to local storage`);
    }
}